import resume from '../assets/pdf/resume.pdf'

export const headerData = {
    name: 'Anuj Sachan',
    title: "Kotlin Multiplatform developer",
    desciption:"Software Developer , Love to fill my docker with new technologies.",
    image: 'https://avatars.githubusercontent.com/u/26837182',
    resumePdf: resume
}
